const MERCHANT_PORTAL_SELECTION_KEY = 'coop_merchant_portal_selection';

type MerchantPortalSelection = {
  userId: string;
  merchantId: string;
};

export function readMerchantPortalSelection(userId: string): string | null {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(MERCHANT_PORTAL_SELECTION_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as MerchantPortalSelection;
    if (parsed?.userId !== userId || typeof parsed.merchantId !== 'string' || !parsed.merchantId.trim()) {
      return null;
    }

    return parsed.merchantId;
  } catch {
    return null;
  }
}

export function saveMerchantPortalSelection(userId: string, merchantId: string) {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(MERCHANT_PORTAL_SELECTION_KEY, JSON.stringify({ userId, merchantId }));
  } catch {
    // ignore
  }
}

export function clearMerchantPortalSelection() {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.removeItem(MERCHANT_PORTAL_SELECTION_KEY);
  } catch {
    // ignore
  }
}
